//
// UPDATED
//

export const Color = {
  black: '#222222',
  baseColor: '#eee',
  foreColor: '#f5f5f5',
  // Aliasing foreColor because people tend to look for white
  white: '#fff',
  whiteTransparent: '#ffffffdd',
  blackTransparent: '#222222AB',
  gray: '#878787',
  grayLight: '#DADADA',
  grayLight2: '#ECECEC',
  grayLight3: '#F5F5F5',
  grayHue2: '#3d4447',
  grayHue3: '#212121',
  grayHue4: '#e0e0e0',
  grayHue5: '#bbb',
  grayHue6: '#a5a4a5',
  grayHue7: '#E1E1E1',
  blueHue1: '#004394',
  blueHue2: '#3a75b9',
  blueHue3: '#29abe2',
  blueHue4: '#ccdff1',
  blueHue5: '#f2f5f9',
  blueHue6: '#003366',
  blueHue7: '#007aff',
  blueHue8: '#006CF0',
  blueHue9: '#7CD6E2',
  primary: '#004394',
  primaryHue2: '#036',
  primaryHue3: '#38d',
  primaryHue4: '#dfeef7',
  primaryHue5: '#00A9DF',
  primaryHue6: '#1166BB',
  lightBlue: '#76ddfb',
  selectHealth: '#4e8a03',
  secondary: '#77b6b4',
  secondaryHue3: '#4aa0b5',
  tertiary: '#354251',
  tertiaryHue2: '#243243',
  filterSelected: '#604AB3',
  textLight: '#444444',
  textDark: '#222222',
  inverted: '#fff',
  baseDark: '#ccc',
  tealOriginal: '#17A2B8',
  tealLight: '#6DC9D8',
  cyanBlueLight: '#C4DBF3',

  MHlogoDarkBlue: '#025EA9',
  MHlogoLightBlue: '#4E83C2',

  orange: '#FF9400',

  yellow: '#fEE44D',
  lightYellow: '#fffde6',
  starRatingYellow: '#FFBB22',
  billDueOrange: '#DE6902',
  red: '#E22C35',
  redLight: '#FBE5E6',
  green: '#75A201',
  purple: '#512EA8',
  darkPuple: '#512DA8',
  lightPurple: '#7E4EF2',

  accent: '#512DA8',
  accentHue2: '#6f45d5',
  accentHue3: '#EDE8FB',
  buttonDisabled: '#bfbfbf',
  inputBackground: '#fafafa',
  inputTextColor: '#121212',
  transparent: 'rgba(255, 255, 255, 0.3)',
  link: '#3388DD',
  // custom colors
  grayLight4: '#fffefe',
  grayLight5: '#fffeff',
  grayLight6: '#bdbdbd',
  grayLight7: '#D8D8D8',
  // random color
  graySidebarHeading: '#444',
  graySidebarDivider: '#C7C7CC',
  graySidebarLink: '#222',
  graySidebarIcon: '#777',
  graySidebarAvatar: '#9A9A9A',
  turquoiseDark: '#107686',
  turqoiseLight: '#A7D8DF',
  navy: '#213245',

  // Buttons
  primaryUnderlay: '#0062cc',
  flatUnderlay: '#e9e9e9',

  // Progress Bar
  turquoiseDarkBar: '#2CA2B8',
  turquoiseLightBar: '#D1ECF1',

  // Deprecated
  teal: '#1da2b6',
  offBlack: '#3d4447',
  primaryDark: '#004394',
  warning: '#ffc107',
  error: '#b85151',
  soft: '#d6e9fd',
  backDrop: 'rgba(0,0,0,.5)'
} as const;
export const accent = '#512DA8';
export const baseColor = '#eee';
export const foreColor = '#fff';
export const white = '#fff';

export const gray = '#878787';
export const grayHue2 = '#3d4447';
export const grayHue3 = '#212121';
export const grayHue4 = '#e0e0e0';
export const grayHue5 = '#bbb';

export const primary = '#004394';
export const primaryHue2 = '#036';
export const primaryHue3 = '#38d';
export const primaryHue4 = '#dfeef7';
export const primaryHue5 = '#00A9DF';

export const selectHealth = '#4e8a03';

export const secondary = '#77b6b4';
export const secondaryHue3 = '#4aa0b5';

export const tertiary = '#354251';
export const tertiaryHue2 = '#243243';
export const textLight = '#444444';
export const textDark = '#222222';
export const inverted = foreColor;

export const red = '#E22C35';

//
// EVALUATING
//

export const buttonDisabled = '#bfbfbf';
export const inputBackground = '#fafafa';
export const inputTextColor = '#121212';

//
// DEPRECATED
//

export const black = '#111111';
export const baseDark = '#ccc';
export const offBlack = '#3d4447';
export const primaryDark = '#004394';
export const teal = '#78B6BF';
export const grayLight = '#d9d9d9';

export const warning = '#ffc107';
export const soft = '#d6e9fd';

// Button colors
export const primaryUnderlay = '#0062cc';
export const flatUnderlay = '#e9e9e9';
